import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class CurrentZoneController extends Controller {
  queryParams = ['forceConnectPopup'];

  @tracked forceConnectPopup = false;
}
